/**
 * Derive the Sub-categories (sub-feature) option list for the currently selected
 * Scenario(s) in My-Brand mode, from the `scenario → sub-features` map returned by
 * `/overview/subfeature-options`.
 *
 * - When no scenario is selected (the BQ "All" case), the pool is every scenario's
 *   sub-features unioned, mirroring the unfiltered summary query.
 * - Otherwise it's the union of the selected scenarios' sub-features.
 * Result is deduped and alphabetically sorted.
 */
export function subFeatureOptionsForScenarios(
  map: Record<string, string[]>,
  scenarios: string[],
): string[] {
  const pool = scenarios.length ? scenarios : Object.keys(map);
  const set = new Set<string>();
  for (const s of pool) (map[s] ?? []).forEach((v) => set.add(v));
  return [...set].sort();
}
